<template>
  <div class="container">
    <div class="top-info">
      <!-- <img src="../../assets/images/banner_bg.png" alt="" class="banner"> -->
      <div class="info-container">
        <div class="user">
          <img :src="userInfo.avatar | default_img" alt="" class="avatar" />
          <div class="info">
            <div class="name flex align-center">
              <span>{{ userInfo.nickname || userInfo.username }}</span>
              <div class="pause-status flex align-center justify-between"  @click="changePause()" v-if="userInfo.is_procurement">
                <span class="status" :class="userInfo.procurement_pause==0?'active':''">{{ userInfo.procurement_pause?'暂停接单':'在线接单' }}</span>
                 <img
                  class="pause-img"
                  src="../../assets/images/procurement/procurement_pause.png"
                />
              </div>
            </div>
            <div class="job-location">
              <span>{{ userInfo.job }}</span>
              <span v-if="userInfo.city">IP属地:{{ userInfo.city }}</span>
            </div>
            <div class="fans-info">
              粉丝 <span>{{ userInfo.fans_count }}</span
              >关注 <span>{{ userInfo.follow_count }}</span>
              收藏与获赞 <span>{{userInfo.cz_count}}</span>
            </div>
            <div class="btn-box">
              <Button @click="onShareClick">
                <div style="display:flex;align-items:center;color:#666666;">
                  <img src="../../assets/images/icon-share-workbench.png" style="width:22px;height:22px;margin:0 !important;" />分享好友
                </div>
              </Button>
              <!-- <Button
                @click="
                  $router.push({ name: 'ShopHome', query: { uid: userInfo.code } })
                "
              >
                <div>
                  <img src="../../assets/images/icon-shop-white.png" />
                  我的店铺
                </div>
              </Button> -->
            </div>
          </div>
        </div>
        <div class="user-balance">
          <div class="balance-wrap">
            <div class="balance-info">
              <div class="balance-info-title">我的积分</div>
              <div class="balance">{{userInfo.point}}</div>
              <a class="balance-detail" href="/workbench/userPoint" target="_blank">积分明细</a>
            </div>
          </div>
          <div class="border-box"></div>
          <div class="balance-wrap">
            <div class="balance-info">
              <div class="balance-info-title">消费券余额</div>
              <div class="balance">{{userInfo.c_coupon || 0}}</div>
              <a class="balance-detail" href="/workbench/userCoupon" target="_blank">消费券明细</a>
            </div>
          </div>
          <div class="balance-wrap">
            <div class="balance-info">
              <div class="balance-info-title">冻结余额</div>
              <div class="balance">{{userInfo.frozen_balance || 0}}</div>
              <a class="balance-detail" style="visibility: hidden">明细&nbsp;</a>
            </div>
          </div>
          <div class="border-box"></div>
          <div class="balance-wrap">
            <div class="balance-info">
              <div class="balance-info-title">账户余额(元)</div>
              <div class="balance">{{userInfo.balance | price_format}}</div>
              <a class="balance-detail" href="/workbench/userBalance" target="_blank">账户明细</a>
            </div>
            <div class="charge-btn" @click="show_charge_pop=true">充值</div>
          </div>
        </div>
      </div>
    </div>

    <div class="btn-container">
      <div class="design" @click="start_draft">
        <div class="content">
          <div class="title">新建款式设计</div>
          <div class="desc">上传设计图，在线一键定制并生产服装</div>
          <div class="btn">
            <img src="../../assets/images/icon-design-btn-ico.png" />
            创建款式设计
          </div>
        </div>
      </div>
      <div class="upload-pic" @click="onCreatePosts(1)">
        <div class="bg-absolute"></div>
        <div class="content">
          <div class="title">发布图片</div>
          <div class="desc">上传图片，发布属于自己的笔记</div>
          <div class="btn">上传图片</div>
        </div>
      </div>
      <div class="upload-video" @click="onCreatePosts(2)">
        <!-- <img src="../../assets/images/img-btn-upload-video.png" /> -->
        <div class="bg-absolute"></div>
        <div class="content">
          <div class="title">发布视频</div>
          <div class="desc">上传视频，发布属于自己的笔记</div>
          <div class="btn">上传视频</div>
        </div>
      </div>
    </div>

    <div class="tool-wrap">
      <div class="tabs-box">
        <div
          class="tabs-item"
          :class="[selected_tab == 1 ? 'active' : '']"
          @click="onTabClick(1)"
        >
          款式草稿
        </div>
        <div
          class="tabs-item"
          :class="[selected_tab == 2 ? 'active' : '']"
          @click="onTabClick(2)"
        >
          我的收藏<span>{{ collect_count }}</span>
        </div>
      </div>
      <div class="search">
        <input
          type="text"
          placeholder="搜索关键词搜索"
          v-model="form_data.keyword"
          class="input"
          @keyup.enter="onSearch"
        />
        <img
          src="../../assets/images/icon-search-workbench.png"
          alt=""
          class="icon-search cursor"
          @click="onSearch"
        />
      </div>
    </div>
    <!-- <h3 class="title">作图记录</h3> -->
    <template v-if="selected_tab == 1 && draft_list.length > 0">
      <div class="list">
        <div
          class="item"
          v-for="(v, k) in draft_list"
          :key="`d` + k"
          @click="edit(v.uuid)"
        >
          <img :src="v.image | default_img(false)" alt="" class="image" />
          <div class="name">{{ v.name || '-' }}</div>
          <div class="time">{{ v.update_time }}</div>
          <div class="mask">
            <img
              src="../../assets/images/icon-magnifier.png"
              alt=""
              class="icon-mag"
            />
            <img
              src="../../assets/images/icon_edit@2x.png"
              alt=""
              class="icon-edit"
              v-if="v.status === 0"
              @click.stop="edit(v.uuid)"
            />
            <img
              src="../../assets/images/icon_delete@2x.png"
              alt=""
              class="icon-delete"
              @click.stop="del(v.uuid)"
            />
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="selected_tab == 2 && infiniteList.length > 0">
      <div
        class="masonry-container"
        style="margin-top: 30px; padding-bottom: 70px"
      >
        <masonry
          :cols="{ default: 6, 1600: 5, 1300: 5, 700: 3, 400: 2 }"
          :gutter="{ default: '30px', 1300: '20px', 700: '15px', 400: '10px' }"
        >
          <div
            v-for="(item, index) in infiniteList"
            :key="index"
            @click.prevent.stop="onArticleDetail(item)"
          >
            <template>
              <div class="masonry-item">
                <img
                  v-if="item.type == 2"
                  src="../../assets/images/icon-play.png"
                  class="play-btn"
                  alt=""
                />
                <!-- <img src="../../assets/images/icon-match-on-list.png" class="match-ico" /> -->
                <div
                  class="remove-collect"
                  @click.prevent.stop="onCollectRemove(item)"
                >
                  移除<Icon type="md-close"></Icon>
                </div>
                <div class="img-container">
                  <img
                    :src="item.cover"
                    @load="onImageLoad"
                    class="masonry-image"
                  />
                </div>
                <div class="item-content">
                  <div class="title">{{ item.title }}</div>
                  <div class="bottom-box">
                    <div class="bottom-item">
                      <img
                        src="../../assets/images/icon-views-workbench-list.png"
                      />
                      <div style="margin-left: 3px">{{ item.view_times }}</div>
                    </div>
                    <div class="bottom-item">
                      <img
                        src="../../assets/images/icon-comment-workbench-list.png"
                      />
                      <div style="margin-left: 3px">
                        {{ item.comment_count }}
                      </div>
                    </div>
                    <div class="bottom-item">
                      <img
                        src="../../assets/images/icon-collect-workbench-list.png"
                      />
                      <div style="margin-left: 3px">{{ item.zan_count }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </masonry>
      </div>
    </template>
    <template v-else>
      <img
        src="../../assets/images/no-data.png"
        style="width: 300px; display: block; margin: 0 auto"
        alt=""
      />
    </template>
    <div class="kefu-box" @click="showChat()" v-show="false">
      <div class="kefu-item">
        <img src="../../assets/images/chat/xiaoxi.png" class="kefu" />
        <div class="badge" v-if="messageNum > 0">{{ messageNum }}</div>
      </div>
      <!-- <div class="kefu-item">
				<img src="../../assets/images/chat/kefu.png" class="kefu" />
			</div> -->
    </div>
    <img
      v-show="isBackToTopVisible"
      src="../../assets/images/icon-to-top.png"
      @click="scrollToTop"
      class="scroll-top"
      ref="backToTop"
    />
    <chat ref="chat"></chat>
    <!-- 帖子详情 -->
    <ArticleDetail
      ref="articleDetail"
      v-if="show_detail"
      @on-close="onCloseArticleDetail"
      :uuid="article_id"
    ></ArticleDetail>
    <!-- 发布笔记 -->
    <create-posts
      ref="createPop"
      v-if="show_creator_pop"
      @close-upload-pop="show_creator_pop = false"
      :incomeType="create_type"
    />
    <!-- 快速定制 -->
    <create-design v-if="show_design_pop" ref="createDesign" @close-design-pop="show_design_pop=false" @on-advanced-mode="(uuid)=>{start_design(uuid)}"></create-design>
    <!-- 充值相关弹窗 -->
    <balance-charge v-if="show_charge_pop" @close-charge-pop="()=>show_charge_pop=false" @on-charge-success="onChargeSuccess"></balance-charge>
    <charge-success v-if="show_charge_success" @close-charge-success="()=>show_charge_success=false" :amount="temp_charge_amount"></charge-success>
    <!-- 充值弹窗结束 -->
  </div>
</template>

<script>
import { GetAllNoRedNum } from "@/api/chat.js";
import { DeleteDraft, DraftList, Profile } from "@/api/index.js";
import { ProcurementPause } from "@/api/procurement";
import { GetMyCollectList, PostsCollect } from "@/api/social";
import ArticleDetail from "@/components/ArticleDetail";
import BalanceCharge from '@/components/BalanceCharge';
import ChargeSuccess from '@/components/ChargeSuccess';
import Chat from "@/components/Chat.vue";
import CreateDesign from "@/components/CreateDesign";
import CreatePosts from "@/components/CreatePosts.vue";
import infiniteMix from "@/mixins/infinite";
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "WorkbenchHome",
  components: {
    Chat,
    ArticleDetail,
    CreatePosts,
    CreateDesign,
    BalanceCharge,
    ChargeSuccess
  },
  mixins: [infiniteMix],
  data() {
    return {
      form_data: {
        keyword: "",
      },
      draft_list: [],
      draft_page: 1,
      draft_page_size: 10,
      draft_loading: false,
      draft_ended: false,
      messageNum: 0,
      selected_tab: 1,
      isBackToTopVisible: false,
      collect_count: 0,
      show_detail: false,
      show_creator_pop: false,
      create_type: "",
      show_design_pop:false,
      show_charge_pop:false,
      show_charge_success:false,
      temp_charge_amount:'',
      article_id:''
    };
  },
  computed: {
    ...mapState(["userInfo", "setting"]),
    avatar() {
      return this.profile.avatar || require("@/assets/images/avatar.png");
    },
    is_login() {
      return this.$store.state.is_login;
    },
  },
  async mounted() {
    await this.$store.dispatch('getUser');
    const login_first = await localStorage.getItem("first_login");
    // console.log('login_first');
    if (login_first === 'true') {
      localStorage.setItem("first_login",false);
      if(this.setting.is_quick_design_open > 0) {
        this.show_design_pop = true;
      }
      // this.$layer.msg("登录成功");
    }
    window.addEventListener("scroll", this.handleScroll);
    axios
      .all([this.getProfile(), this.getDraftList(true)])
      .then(axios.spread(() => {}));
    this.getAllNoRedNum();
    this.getInfiniteList(true);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    changePause() {
       ProcurementPause().then(()=>{
        this.$store.dispatch('getUser');
       })
    },
    onChargeSuccess({amount}){
        console.log('on-charge-success',amount);
        this.temp_charge_amount = amount
        this.show_charge_pop = false;
        this.show_charge_success = true;
    },
    onSearch(){
      const {selected_tab} = this;
      switch(selected_tab){
        case 1:
          this.getDraftList(true);
          break;
        case 2:
          this.getInfiniteList(true);
          break;
      }
    },
    async onShareClick() {
      const text = `${window.location.origin}/shop/home?uid=${this.userInfo.code}`;
      await navigator.clipboard.writeText(text);
      this.$layer.msg("分享链接复制成功,请发送给好友~");
    },
    onCreatePosts(type) {
      if (!this.is_login) {
        this.$router.replace({ name: "Login" });
        return;
      }
      this.create_type = type;
      this.show_creator_pop = true;
      // console.log('ref',this.$refs.createPop);
      // console.log(type);
    },
    onCloseArticleDetail() {
      this.show_detail = false;
    },
    onTabClick(type) {
      this.selected_tab = type;
      if (type == 1) {
        this.getDraftList(true);
      } else {
        this.getInfiniteList(true);
      }
    },
    async getInfiniteData(pageIndex, pageSize) {
      try {
        const {keyword} = this.form_data;
        const { data } = await GetMyCollectList({
          page: pageIndex,
          limit: pageSize,
          keyword
        });
        const res = {};
        if (!data) {
          res.data = [];
          return res;
        }
        this.collect_count = data.count;
        res.data = data.list ? data.list : [];
        console.log("res", res);
        return res;
      } catch (e) {
        console.log("infiniteList", e);
        const res = {};
        res.data = [];
        return res;
      }
    },
    handleScroll:_.debounce(function(){
				this.isBackToTopVisible = window.pageYOffset > 300; // 滚动超过 300px 显示

        // 触底加载逻辑
        const scrollTop = window.pageYOffset;
        const windowHeight = window.innerHeight;
        const documentHeight = document.body.scrollHeight;

        if (
          scrollTop + windowHeight >= documentHeight - 100
        ) {
          if (this.selected_tab === 1 && !this.draft_ended) {
            this.getDraftList();
          } else if (this.selected_tab === 2 && !this.infiniteEnded) {
            this.getInfiniteList();
          }
      }
    }, 200),
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    onArticleDetail(item) {
      console.log("aaa-click", item);
      this.article_id = item.uuid;
      this.show_detail = true;
    },
    async onCollectRemove(item) {
      console.log("remove-item", item);
      try {
        await PostsCollect({ uuid: item.uuid });
        this.$layer.msg("取消收藏成功");
        this.getInfiniteList(true);
      } catch (e) {
        console.log("取消收藏异常", e);
      }
    },
    onImageLoad() {
      this.$nextTick(() => {
        this.$refs.masonryWall?.reCalculate();
      });
    },
    start_draft() {
      if(this.setting.is_quick_design_open > 0) {
        this.show_design_pop = true;
      } else {
        let route = this.$router.resolve({ name: "WorkBenchDesign" })
        window.open(route.href, '_blank')
      }
    },
    edit(uuid) {
      let route = this.$router.resolve({ name: "WorkBenchDesign", query: { uuid } })
      window.open(route.href, '_blank')
    },
    del(uuid) {
      this.$DModal.confirm({
        content: "确认删除该作图记录么？",
        onOK: () => {
          DeleteDraft({ uuid })
            .then(() => {
              this.$layer.msg(`操作成功`);
              const index = this.draft_list.findIndex(item => item.uuid === uuid);
              if (index !== -1) {
                this.draft_list.splice(index, 1);
              }
            });
        },
      });
    },
    async getProfile() {
      return Profile().then((response) => {
        return response;
      });
    },
    async getDraftList(refresh) {
      if (refresh) {
        this.draft_page = 1;
        this.draft_ended = false;
        this.draft_list = [];
      }
      if (this.draft_ended || this.draft_loading) return;
      this.draft_loading = true;
      try {
        const { data } = await DraftList({
          ...this.form_data,
          page: this.draft_page,
          limit: this.draft_page_size,
        });
        const list = Array.isArray(data) ? data : (data.list || []);
        if (refresh) {
          this.draft_list = list;
        } else {
          this.draft_list.push(...list);
        }
        this.draft_page++;
        if (list.length < this.draft_page_size) {
          this.draft_ended = true;
        }
      } catch (e) {
        console.log("getDraftList error", e);
      } finally {
        this.draft_loading = false;
      }
    },
    showChat() {
      this.$refs["chat"].showChat();
    },
    async getAllNoRedNum() {
      let { data } = await GetAllNoRedNum();
      this.messageNum = data.chatNum;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0 70px 0 30px;
  background: white;
  text-align: left;
  .scroll-top {
    position: fixed;
    bottom: 130px;
    right: 34px;
    width: 46px;
    height: 46px;
    cursor: pointer;
  }

  .info-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 40px;
    .user {
      display: flex;
      align-items: center;
      .avatar {
        width: 110px;
        height: 110px;
        border-radius: 50%;
        margin-right: 20px;
        object-fit: cover;
      }
      .info {
        .name {
          color: #1f1f1f;
          font-size: 20px;
        }
        .pause-status{
            margin-left: 13px;
            width: 86px;
            height: 24px;
            background: #F5F5F5;
            border-radius: 12px 12px 12px 12px;
            border: 1px solid #E2E4E5;
            padding: 0 10px;
            cursor:pointer;
            .status{
              font-size: 12px;
              color: #999999;
            }
            .active{
                color: #1FD76D;
            }
            .pause-img{
                width: 10px;
                height: 11px;
            }
        }
        .job-location {
          color: #2b2b2b;
          font-size: 12px;
          span {
            margin-right: 20px;
          }
        }
        .fans-info {
          color: #808080;
          font-size: 14px;
          span {
            font-size: 16px;
            color: #2b2b2b;
            margin-right: 20px;
          }
        }
        .btn-box {
          font-size: 14px;
          Button {
            font-size: 14px;
            border-radius: 10px;
            &:nth-child(1) {
              color:#666666;
              // margin-right: 20px;
            }
            &:nth-child(2) {
              img {
                width: 22px;
                height: 22px;
                // margin-right: 10px;
                align-self: center;
              }
              div {
                display: flex;
                align-items: center;
              }
              background: #ff5967;
              color: white;
            }
          }
        }
      }
    }
    .user-balance{
      background:rgba(245,245,245,0.5);
      border-radius:20px;
      display:flex;
      align-items:center;
      .border-box{
        width: 1px;
        height: 100px;
        background: #E0E0E0;
        opacity: 0.5;
      }
      .balance-wrap{
        padding:35px 40px 35px 60px;
        display:flex;
        align-items:center;
        justify-content:space-between;
        column-gap:100px;
        .balance-info{
          flex:1;
          display:flex;
          flex-direction:column;
          row-gap:15px;
          .balance-info-title{
            color:#1f1f1f;
            font-size:14px;
            white-space:nowrap;
            text-overflow:ellipsis;
            overflow:hidden;
          }
          .balance{
            color:#1f1f1f;
            font-weight:bold;
            font-size:24px;
            white-space:nowrap;
            text-overflow:ellipsis;
            overflow:hidden;
          }
          .balance-detail{
            color:#4ab0f0;
            font-size:12px;
            text-decoration: none;
            white-space:nowrap;
            text-overflow:ellipsis;
            overflow:hidden;
          }
        }
        .charge-btn{
          color:#ffffff;
          width:80px;
          height:34px;
          background:#ff5967;
          line-height:34px;
          text-align:center;
          border-radius:5px;
          cursor:pointer;
        }
      }
    }
  }
  .btn-container {
    display: flex;
    align-items: center;
    margin-top: 35px;
    height: 200px;
    // height:243px;
    .design {
      // width:700px;
      flex: 1 0 700px;
      height: 100%;
      background-image: url(../../assets/images/img-btn-design.png);
      background-size: cover;
      background-repeat: no-repeat;
      margin-right: 20px;
      cursor: pointer;
      .content {
        padding: 30px;
        .title {
          font-size: 22px;
          color: black;
          font-weight: bold;
        }
        .desc {
          margin-top: 10px;
          font-size: 16px;
          color: #1a1a1a;
          margin-bottom: 30px;
        }

        .btn {
          border-radius: 10px;
          background: #ff5967;
          color: white;
          width: 180px;
          height: 46px;
          font-size: 16px;
          cursor: pointer;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          img {
            width: 24px;
            height: 24px;
            margin-right: 10px;
          }
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
    .upload-pic {
      // width:390px;
      flex: 1 0 390px;
      height: 100%;
      position: relative;
      background: #ff755c;
      margin-right: 20px;
      border-radius: 20px;
      cursor: pointer;
      .bg-absolute {
        background: url(../../assets/images/img-btn-upload-pic.png);
        background-size: cover;
        background-repeat: no-repeat;
        width: 153px;
        height: 107px;
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 1;
      }
      .content {
        padding: 30px;
        z-index: 2;
        .title {
          font-size: 22px;
          color: #ffffff;
          font-weight: bold;
        }
        .desc {
          margin-top: 10px;
          font-size: 16px;
          color: #ffffff;
          margin-bottom: 30px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          position: relative;
          z-index: 3;
        }
        .btn {
          border-radius: 10px;
          background: #ffffff;
          width: 130px;
          height: 46px;
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
    .upload-video {
      // width:390px;
      flex: 1 0 390px;
      height: 100%;
      background: #3388ff;
      border-radius: 20px;
      position: relative;
      cursor: pointer;
      .bg-absolute {
        background-image: url(../../assets/images/img-btn-upload-video.png);
        background-size: cover;
        background-repeat: no-repeat;
        width: 161px;
        height: 119px;
        position: absolute;
        right: 0;
        bottom: 0;
      }
      .content {
        z-index: 100;
        padding: 30px;
        .title {
          font-size: 22px;
          color: #ffffff;
          font-weight: bold;
        }
        .desc {
          margin-top: 10px;
          font-size: 16px;
          color: #ffffff;
          margin-bottom: 30px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          position: relative;
          z-index: 3;
        }
        .btn {
          border-radius: 10px;
          background: #ffffff;
          width: 130px;
          height: 46px;
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }
    }
  }

  .tool-wrap {
    display: flex;
    justify-content: space-between;
    // margin: 40px 0 10px 0;
    margin-top: 40px;
    .tabs-box {
      display: flex;
      align-items: center;
      font-size: 18px;
      .tabs-item {
        margin-right: 30px;
        color: #666666;
        cursor: pointer;
        &.active {
          color: #1a1a1a;
          font-weight: bold;
        }
        span {
          font-size: 16px;
        }
      }
    }
    .search {
      // position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #f3f4f6;
      width: 300px;
      height: 50px;
      border-radius: 25px;
      .icon-search {
        width: 20px;
        height: 20px;
        margin-right: 20px;
      }
      .input {
        width: calc(100% - 40px);
        height: 100%;
        line-height: 50px;
        border-radius: 25px;
        padding-left: 20px;
        padding-right: 10px;
        background: #f3f4f6;
        font-size: 14px;
        outline: none;
        border: none;
      }
    }
  }

  .title {
    color: #68696a;
    font-size: 18px;
  }

  .list {
    padding: 30px 0 80px 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap:20px;
    .item {
      position: relative;
      flex:0 0 calc(100% / 5 - 20px);
      // width: 240px;
      // margin-right: 20px;
      // margin-bottom: 20px;
      // margin-top: 20px;
      cursor: pointer;
      .image {
        // width: 240px;
        width:100%;
        height: 240px;
        object-fit: cover;
        border-radius: 10px;
        border: 1px solid #ebedf2;
      }
      .name {
        margin-top: 5px;
        font-size: 14px;
        color: #17181a;
      }
      .time {
        margin-top: 5px;
        font-size: 12px;
        color: #828383;
      }
      .mask {
        display: none;
      }
      &:hover {
        .mask {
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 240px;
          z-index: 10;
          background: rgba(0, 0, 0, 0.35);
          border-radius: 10px;
          .icon-mag {
            position: absolute;
            width: 40px;
            height: 40px;
            top: 96px;
            left: 99px;
          }
          .icon-edit {
            position: absolute;
            width: 30px;
            height: 30px;
            top: 11px;
            right: 47px;
          }
          .icon-delete {
            position: absolute;
            width: 30px;
            height: 30px;
            top: 11px;
            right: 11px;
          }
        }
      }
      &:nth-child(6n) {
        margin-right: 0;
      }
    }
  }
  .kefu-box {
    position: fixed;
    top: 500px;
    right: 5px;
    .kefu-item {
      position: relative;
      margin-bottom: 10px;
      width: 70px;
      height: 70px;
      background: #ffffff;
      box-shadow: 0px 0px 5px 0px #cbc5c5;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .kefu {
        width: 60px;
        height: 60px;
      }
      .badge {
        background-color: #f34d37;
        border-radius: 10px;
        color: #fff;
        display: inline-block;
        font-size: 12px;
        height: 18px;
        line-height: 18px;
        padding: 0 6px;
        text-align: center;
        white-space: nowrap;
        border: 1px solid #fff;
        position: absolute;
        top: -5px;
        right: -5px;
      }
    }
  }

  /**瀑布流样式开始 */
  .masonry-container {
    max-width: 1520px;
    margin: 0 auto;
    .masonry-item {
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      margin-bottom: 20px;
      width: 236px;
      cursor: pointer;
      position: relative;
      .remove-collect {
        display: none;
      }
      &:hover .remove-collect {
        position: absolute;
        background: rgba(0, 0, 0, 0.4);
        color: white;
        font-size: 14px;
        line-height: normal;
        padding: 4px 14px;
        border-bottom-right-radius: 10px;
        border-top-left-radius: 10px;
        display: flex;
        align-items: center;
        z-index: 10;
      }
      .play-btn {
        width: 30px;
        height: 30px;
        position: absolute;
        top: 10px;
        right: 10px;
      }
      .match-ico {
        position: absolute;
        width: 32px;
        height: 32px;
        right: 10px;
        bottom: 100px;
      }

      .img-container {
        position: relative;
        display: inline-block;
        width: fit-content;
        img {
          display: block;
          width: 100%;
          height: auto;
        }

        &:hover::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(128, 128, 128, 0.4);
          pointer-events: none;
          border-radius: 10px;
        }

        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(128, 128, 128, 0.05);
          pointer-events: none;
          border-radius: 10px;
        }

        .masonry-image {
          width: 100%;
          display: block;
          object-fit: contain;
          border-radius: 10px;
        }
      }

      .item-content {
        padding: 15px 5px;
        .title {
          font-size: 16px;
          color: #000000;
        }
        .bottom-box {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-top: 10px;

          .bottom-item {
            display: flex;
            align-items: center;
            &:nth-child(2) {
              margin-left: 10px;
              margin-right: 10px;
            }
            img {
              width: 20px;
              height: 20px;
            }
          }

          .views-box {
            display: flex;
            align-items: center;
          }

          .comment-box {
            display: flex;
            align-items: center;
          }

          .like-box {
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }

  /* 响应式调整列数 */
  @media (max-width: 768px) {
    .masonry-container {
      --columns: 2;
    }
  }

  @media (max-width: 480px) {
    .masonry-container {
      --columns: 1;
    }
  }
  /**瀑布流样式结束 */
}
@media (min-width: 1280px) and (max-width: 1679px) {
  .container {
    padding: 0 5px 0 27px;
    .scroll-top {
      position: fixed;
      bottom: 230px;
      right: 34px;
      width: 46px;
      height: 46px;
      cursor: pointer;
    }

    .info-container {
      width: 100%;
      // margin-top: 36px;
      .user {
        .avatar {
          width: 99px;
          height: 99px;
          border-radius: 50%;
          margin-right: 18px;
        }
        .info {
          .name {
            font-size: 18px;
          }
          .job-location {
            font-size: 12px;
            span {
              margin-right: 18px;
            }
          }
          .fans-info {
            font-size: 12px;
            span {
              font-size: 14px;
              margin-right: 18px;
            }
          }
        }
      }
      .btn-box {
        font-size: 12px;
        Button {
          border-radius: 9px;
          &:nth-child(1) {
            margin-right: 18px;
          }
          &:nth-child(2) {
            img {
              width: 19.8px;
              height: 19.8px;
              margin-right: 9px;
            }
          }
        }
      }
    }
    .btn-container {
      margin-top: 31.5px;
      height: 180px;
      .design {
        flex: 1 0 500px;
        height: 100%;
        background-size: 100% 100%;
        margin-right: 18px;
        .content {
          padding: 27px;
          .title {
            font-size: 18px;
          }
          .desc {
            margin-top: 9px;
            font-size: 14px;
            margin-bottom: 27px;
          }

          .btn {
            border-radius: 10px;
            width: 162px;
            height: 41.4px;
            font-size: 14px;
            img {
              width: 21.6px;
              height: 21.6px;
              margin-right: 9px;
            }
          }
        }
      }
      .upload-pic {
        // width:390px;
        flex: 1 0 300px;
        height: 100%;
        margin-right: 18px;
        border-radius: 18px;
        .bg-absolute {
          width: 137.7px;
          height: 96.3px;
          right: 0;
          bottom: 0;
          z-index: 1;
        }
        .content {
          padding: 27px;
          z-index: 2;
          .title {
            font-size: 18px;
            color: #ffffff;
            font-weight: bold;
          }
          .desc {
            margin-top: 10px;
            font-size: 14px;
            color: #ffffff;
            margin-bottom: 30px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .btn {
            border-radius: 10px;
            width: 117px;
            height: 41.4px;
            font-size: 14px;
          }
        }
      }
      .upload-video {
        // width:390px;
        flex: 1 0 300px;
        height: 100%;
        border-radius: 20px;
        .bg-absolute {
          width: 144.9px;
          height: 107.1px;
          right: 0;
          bottom: 0;
        }
        .content {
          z-index: 100;
          padding: 27px;
          .title {
            font-size: 18px;
          }
          .desc {
            margin-top: 10px;
            font-size: 14px;
            margin-bottom: 27px;
          }
          .btn {
            border-radius: 10px;
            width: 117px;
            height: 41.4px;
            font-size: 14px;
          }
        }
      }
    }

    .tool-wrap {
      margin-top: 36px;
      .tabs-box {
        font-size: 16px;
        .tabs-item {
          margin-right: 27px;
          span {
            font-size: 14px;
          }
        }
      }
      .search {
        width: 270px;
        height: 45px;
        border-radius: 22.5px;
        .icon-search {
          width: 18px;
          height: 18px;
          margin-right: 18px;
        }
        .input {
          width: calc(100% - 36px);
          height: 100%;
          line-height: 45px;
          border-radius: 22.5px;
          padding-left: 18px;
          padding-right: 9px;
          font-size: 12px;
        }
      }
    }

    .title {
      font-size: 16px;
    }

    .list {
      padding: 27px 0 72px 0;
      .item {
        // width: 216px;
        // margin-right: 18px;
        // margin-bottom: 18px;
        .image {
          width: 100%;
          height: 216px;
        }
        .name {
          margin-top: 13.5px;
          font-size: 12px;
        }
        .time {
          margin-top: 9px;
          font-size: 10px;
        }
        .mask {
          display: none;
        }
        &:hover {
          .mask {
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 216px;
            .icon-mag {
              width: 36px;
              height: 36px;
              top: 86.4px;
              left: 89.1px;
            }
            .icon-edit {
              width: 27px;
              height: 27px;
              top: 9.9px;
              right: 42.3px;
            }
            .icon-delete {
              width: 27px;
              height: 27px;
              top: 9.9px;
              right: 9.9px;
            }
          }
        }
        &:nth-child(6n) {
          margin-right: 0;
        }
      }
    }
    .kefu-box {
      position: fixed;
      top: 500px;
      right: 5px;
      .kefu-item {
        position: relative;
        margin-bottom: 10px;
        width: 70px;
        height: 70px;
        background: #ffffff;
        box-shadow: 0px 0px 5px 0px #cbc5c5;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .kefu {
          width: 60px;
          height: 60px;
        }
        .badge {
          background-color: #f34d37;
          border-radius: 10px;
          color: #fff;
          display: inline-block;
          font-size: 12px;
          height: 18px;
          line-height: 18px;
          padding: 0 6px;
          text-align: center;
          white-space: nowrap;
          border: 1px solid #fff;
          position: absolute;
          top: -5px;
          right: -5px;
        }
      }
    }

    /**瀑布流样式开始 */
    .masonry-container {
      max-width: 1368px;
      margin: 0 auto;
      .masonry-item {
        background: #fff;
        border-radius: 8px;
        overflow: hidden;
        // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        margin-bottom: 20px;
        width: 212.4px;
        cursor: pointer;
        position: relative;
        .remove-collect {
          display: none;
        }
        &:hover .remove-collect {
          position: absolute;
          background: rgba(0, 0, 0, 0.4);
          color: white;
          font-size: 14px;
          line-height: normal;
          padding: 4px 14px;
          border-bottom-right-radius: 10px;
          border-top-left-radius: 10px;
          display: flex;
          align-items: center;
        }
        .play-btn {
          width: 30px;
          height: 30px;
          position: absolute;
          top: 10px;
          right: 10px;
        }
        .match-ico {
          position: absolute;
          width: 32px;
          height: 32px;
          right: 10px;
          bottom: 100px;
        }
        .masonry-image {
          width: 100%;
          display: block;
          object-fit: contain;
          border-radius: 10px;
        }

        .item-content {
          padding: 15px 5px;
          .title {
            font-size: 16px;
            color: #000000;
          }
          .bottom-box {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top: 10px;

            .bottom-item {
              display: flex;
              align-items: center;
              &:nth-child(2) {
                margin-left: 10px;
                margin-right: 10px;
              }
              img {
                width: 20px;
                height: 20px;
              }
            }

            .views-box {
              display: flex;
              align-items: center;
            }

            .comment-box {
              display: flex;
              align-items: center;
            }

            .like-box {
              display: flex;
              align-items: center;
            }
          }
        }
      }
    }

    /* 响应式调整列数 */
    @media (max-width: 768px) {
      .masonry-container {
        --columns: 2;
      }
    }

    @media (max-width: 480px) {
      .masonry-container {
        --columns: 1;
      }
    }
    /**瀑布流样式结束 */
  }
}
@media (max-width: 1279px) {
  .container {
    padding: 0 56px 0 24px;
    .scroll-top {
      position: fixed;
      bottom: 130px;
      right: 34px;
      width: 46px;
      height: 46px;
      cursor: pointer;
    }

    .info-container {
      width: 100%;
      margin-top: 32px;
      .user {
        .avatar {
          width: 88px;
          height: 88px;
          border-radius: 50%;
          margin-right: 16px;
        }
        .info {
          .name {
            font-size: 16px;
          }
          .job-location {
            font-size: 10px;
            span {
              margin-right: 16px;
            }
          }
          .fans-info {
            font-size: 12px;
            span {
              font-size: 14px;
              margin-right: 16px;
            }
          }
        }
      }
      .btn-box {
        font-size: 12px;
        Button {
          border-radius: 10px;
          &:nth-child(1) {
            margin-right: 16px;
          }
          &:nth-child(2) {
            img {
              width: 17.6px;
              height: 17.6px;
              margin-right: 8px;
            }
          }
        }
      }
    }
    .btn-container {
      margin-top: 28px;
      height: 160px;
      .design {
        flex: 1 0 420px;
        height: 100%;
        margin-right: 16px;
        background-size: 100% 100%;
        .content {
          padding: 24px;
          .title {
            font-size: 18px;
          }
          .desc {
            margin-top: 8px;
            font-size: 14px;
            color: #1a1a1a;
            margin-bottom: 24px;
          }

          .btn {
            border-radius: 10px;
            width: 144px;
            height: 36.8px;
            font-size: 14px;
            img {
              width: 19px;
              height: 19px;
              margin-right: 8px;
            }
          }
        }
      }
      .upload-pic {
        flex: 1 0 234px;
        height: 100%;
        margin-right: 16px;
        border-radius: 16px;
        .bg-absolute {
          width: 122.4px;
          height: 85.6px;
          right: 0;
          bottom: 0;
          z-index: 0;
        }
        .content {
          padding: 24px;
          z-index: 2;
          .title {
            font-size: 18px;
          }
          .desc {
            margin-top: 8px;
            font-size: 14px;
            margin-bottom: 24px;
          }
          .btn {
            border-radius: 8px;
            width: 104px;
            height: 36.8px;
            font-size: 14px;
          }
        }
      }
      .upload-video {
        flex: 1 0 234px;
        border-radius: 16px;
        .bg-absolute {
          width: 128.8px;
          height: 95.2px;
          right: 0;
          bottom: 0;
        }
        .content {
          padding: 24px;
          .title {
            font-size: 18px;
          }
          .desc {
            margin-top: 8px;
            font-size: 14px;
            margin-bottom: 23.1px;
          }
          .btn {
            border-radius: 8px;
            width: 104px;
            height: 36.8px;
            font-size: 14px;
          }
        }
      }
    }

    .tool-wrap {
      margin-top: 32px;
      .tabs-box {
        font-size: 16px;
        .tabs-item {
          margin-right: 24px;
          span {
            font-size: 14px;
          }
        }
      }
      .search {
        width: 240px;
        height: 40px;
        border-radius: 25px;
        .icon-search {
          width: 16px;
          height: 16px;
          margin-right: 16px;
        }
        .input {
          width: calc(100% - 32px);
          height: 100%;
          line-height: 40px;
          border-radius: 25px;
          padding-left: 16px;
          padding-right: 8px;
          font-size: 12px;
        }
      }
    }

    .title {
      font-size: 16px;
    }

    .list {
      padding: 24px 0 64px 0;
      .item {
        // width: 100%;
        // margin-right: 16px;
        // margin-bottom: 16px;
        .image {
          width: 100%;
          height: 192px;
        }
        .name {
          margin-top: 12px;
          font-size: 12px;
        }
        .time {
          margin-top: 8px;
          font-size: 12px;
        }
        &:hover {
          .mask {
            height: 192px;
            .icon-mag {
              position: absolute;
              width: 32px;
              height: 32px;
              top: 76.7px;
              left: 79.2px;
            }
            .icon-edit {
              width: 24px;
              height: 24px;
              top: 8.8px;
              right: 37.6px;
            }
            .icon-delete {
              width: 24px;
              height: 24px;
              top: 8.8px;
              right: 8.8px;
            }
          }
        }
        &:nth-child(6n) {
          margin-right: 0;
        }
      }
    }
    .kefu-box {
      position: fixed;
      top: 500px;
      right: 5px;
      .kefu-item {
        position: relative;
        margin-bottom: 10px;
        width: 70px;
        height: 70px;
        background: #ffffff;
        box-shadow: 0px 0px 5px 0px #cbc5c5;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .kefu {
          width: 60px;
          height: 60px;
        }
        .badge {
          background-color: #f34d37;
          border-radius: 10px;
          color: #fff;
          display: inline-block;
          font-size: 12px;
          height: 18px;
          line-height: 18px;
          padding: 0 6px;
          text-align: center;
          white-space: nowrap;
          border: 1px solid #fff;
          position: absolute;
          top: -5px;
          right: -5px;
        }
      }
    }

    /**瀑布流样式开始 */
    .masonry-container {
      max-width: 1216px;
      margin: 0 auto;
      .masonry-item {
        background: #fff;
        border-radius: 8px;
        overflow: hidden;
        // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        margin-bottom: 16px;
        width: 188.8px;
        cursor: pointer;
        position: relative;
        .remove-collect {
          display: none;
        }
        &:hover .remove-collect {
          font-size: 12px;
          padding: 3.2px 11.2px;
        }
        .play-btn {
          width: 24px;
          height: 24px;
          top: 8px;
          right: 8px;
        }
        .match-ico {
          width: 25.6px;
          height: 25.6px;
          right: 8px;
          bottom: 80px;
        }
        .masonry-image {
          width: 100%;
          border-radius: 10px;
        }

        .item-content {
          padding: 12px 4px;
          .title {
            font-size: 14px;
          }
          .bottom-box {
            margin-top: 8px;
            .bottom-item {
              &:nth-child(2) {
                margin-left: 8px;
                margin-right: 8px;
              }
              img {
                width: 16px;
                height: 16px;
              }
            }
          }
        }
      }
    }

    /* 响应式调整列数 */
    @media (max-width: 768px) {
      .masonry-container {
        --columns: 2;
      }
    }

    @media (max-width: 480px) {
      .masonry-container {
        --columns: 1;
      }
    }
    /**瀑布流样式结束 */
  }
}
</style>
